import { useSelector } from "react-redux";
import AdminDashboard from "./AdminDashboard";
import UserDashboard from "./UserDashboard";
import Cookies from "js-cookie";


const Dashboard = () => {
    const token = Cookies.get("token");
    const userDetails = useSelector((state) => state.root.userDetails);
    return (
        <>
            {userDetails?.type === 2 ? <AdminDashboard /> : token && <UserDashboard />}
        </>
    )
}
export default Dashboard;
